import React from 'react'
import './styles/MetarDetailSectionItem.css'
import classnames from 'classnames'

const MetarDetailSectionItem = props => {
  if(!props.value) {
    return null
  }
  return (
    <div className={classnames("metarDetailSectionItem", props.className)}>
      <div className="metarDetailSectionItemHeader subText">
        {props.header}
      </div>
      <div className="metarDetailSectionItemValue displayValue">
        {props.value}
      </div>
      <div className="metarDetailSectionItemFooter subText">
        {props.footer}
      </div>
    </div>
  )
}

export default MetarDetailSectionItem



// WEBPACK FOOTER //
// ./src/components/MetarDetailSectionItem.js